import { render, staticRenderFns } from "./ModalTableTcpl3.vue?vue&type=template&id=63916552&"
import script from "./ModalTableTcpl3.vue?vue&type=script&lang=js&"
export * from "./ModalTableTcpl3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports